import { AllSelection, type Command } from "prosemirror-state";

export const ignoreIfAllSelection: Command = (state) => {
	if (!(state.selection instanceof AllSelection)) {
		return false;
	}

	return true;
};
